import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { SiteHeader } from "@/components/SiteHeader";
import { Footer } from "@/components/BusinessSection";
import { BlockRenderer } from "@/components/cms/BlockRenderer";

export default function CmsPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(undefined); // undefined=loading, null=404

  useEffect(() => {
    let live = true;
    setPage(undefined);
    api.cmsPublic(slug).then((d) => { if (live) setPage(d); }).catch(() => { if (live) setPage(null); });
    return () => { live = false; };
  }, [slug]);

  useEffect(() => { if (page?.seo_title) document.title = `${page.seo_title} · HomeRange`; }, [page]);

  return (
    <div className="bg-paper min-h-screen">
      <SiteHeader />
      {page === undefined ? (
        <div className="py-40 grid place-items-center"><Loader2 className="animate-spin text-forest" /></div>
      ) : page === null ? (
        <div className="py-40 text-center px-6" data-testid="cms-notfound">
          <p className="font-serif text-4xl text-charcoal">Page not found.</p>
          <p className="text-charcoal/60 mt-2">This page may be unpublished or moved.</p>
        </div>
      ) : (
        <main data-testid="cms-page">
          <BlockRenderer sections={page.sections} />
        </main>
      )}
      <Footer />
    </div>
  );
}
